import { Component, OnInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: "stacked-clustered-column-chart",
    templateUrl: "stacked-clustered-column-chart.component.html",
    styleUrls: ['stacked-clustered-column-chart.component.css', '../../charts.style.scss']
})

export class StackedClusteredColumnChartComponent implements OnInit {
    @Input() chartSpecification: ChartSpecification;
    
    legendPosition: string = "bottom";
    columnSum: string = "";

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "stackedDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.rotate = this.chartSpecification.rotate || false;
        this.chartSpecification.precision = this.chartSpecification.precision || 0;

        // if chart rotated, legend would be on the right position and display column sum
        if (this.chartSpecification.rotate) {
            this.legendPosition = "right";
            this.columnSum = "[[total]]";
        }

        if (typeof this.chartSpecification.parseDates === "undefined") {
            this.chartSpecification.parseDates = true;
        }
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "rotate": this.chartSpecification.rotate,
                "columnSpacing": this.chartSpecification.columnWidth ?  this.chartSpecification.columnWidth : 0,
                "legend": {
                    "horizontalGap": 1,
                    "useGraphSettings": true,
                    "markerSize": 10,
                    "verticalGap": 0,
                    "equalWidths": true,
                    "position": this.legendPosition,
                },
                "dataProvider": this.chartSpecification.data,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "valueAxes": [{
                    "stackType": "regular",
                    "axisAlpha": 0,
                    "gridAlpha": 0,
                    'gridThickness':0,
                    "labelsEnabled": false,
                    "title": this.chartSpecification.yAxisTitle,
                    "totalText": this.columnSum,
                    "bold": true
                }],
                "graphs": this.getGraphs(),
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "parseDates": this.chartSpecification.parseDates,
                    "gridPosition": "start",
                    "axisAlpha": 0,
                    "gridAlpha": 0,
                    "position": "left"
                },
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }

    getGraphs() {
        let graphs: any[] = [];

        this.chartSpecification.graphs.forEach((item) => {
            graphs.push({
                "balloonText": "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
                "fillAlphas": 1,
                "labelText": "[[value]]",
                "lineAlpha": 0,
                "title": item.title,
                "type": "column",
                "color": '#000000',
                "fillColors": item.color ? item.color : '',
                "newStack": item.newStacked ? item.newStacked : false,
                "valueField": item.fieldName,
                "precision": this.chartSpecification.precision
            })
        });

        return graphs;
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/stacked-clustered-column-chart/stacked-clustered-column-chart.component.ts